import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Address, Associate, Vehicle } from '@quorum/models/xs-resource';
import { ServiceLaneDropdownsFacade } from '@quorum/service-lane-dropdowns/facade';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';

@Component({
  selector: 'svc-create-vehicle',
  templateUrl: './create-vehicle.component.html',
  styleUrls: ['./create-vehicle.component.scss'],
})
export class CreateVehicleComponent implements OnInit {
  vehicle: Vehicle = new Vehicle();
  associate: Associate = new Associate({ ...new Associate(), classId: 'INDIV' });
  address: Address = new Address();
  constructor(
    public serviceLaneFacade: ServiceLaneFacade,
    public serviceLaneDropdownFacade: ServiceLaneDropdownsFacade,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params.vin) {
        this.vehicle.vin = params.vin;
      }
      this.vehicle.rooftopId = 1;
    });

    this.serviceLaneFacade.createVehicle$.subscribe((d) => {
      this.router.navigateByUrl(`vehicle/${d.payload.id}`);
    });
  }

  createVehicle(data: { associate: Associate; address: Address; vehicle: Vehicle; vehicleQueryParams: any }) {
    if (data.vehicle.associateId != null) {
      this.serviceLaneFacade.createVehicleOnServer(data.vehicle);
    } else {
      this.serviceLaneFacade.createVehicleWithAssociateAndAddressOnServer(
        data.vehicle,
        data.associate,
        data.address,
        data.vehicleQueryParams
      );
    }
  }
}
